import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar } from '../../app/navBar.js';
import { catalogApi } from '../../../api/catalogApi.js';
import './createRecipeScreen.css';

const CreateRecipeScreen = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [recipeItems, setRecipeItems] = useState([]);
    const [recipeName, setRecipeName] = useState('');
    const [banner, setBanner] = useState({ message: '', type: '' });

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await catalogApi.getItems();
                setItems(response.data.rows);
            } catch (error) {
                console.error('Failed to fetch items:', error);
            }
        };

        fetchItems();
    }, []);

    const handleAddItem = () => {
        setRecipeItems([...recipeItems, { itemID: '', servingsEaten: 1, servingSize: '' }]);
    };

    const handleItemChange = async (index, event) => {
        const { name, value } = event.target;
        const updatedRecipe = [...recipeItems];

        if (name === 'itemID') {
            if (recipeItems.some(item => item.itemID === value)) {
                alert('Item already selected!');
                return;
            }
            try {
                const response = await catalogApi.getItemDetails(value);
                if (response.data && response.data.row) {
                    updatedRecipe[index] = {
                        ...updatedRecipe[index],
                        itemID: value,
                        servingSize: `${response.data.row.servingSize} ${response.data.row.servingUnit}`
                    };
                } else {
                    console.error('Item details missing in API response');
                    updatedRecipe[index] = { ...updatedRecipe[index], servingSize: '' };
                }
            } catch (error) {
                console.error('Failed to fetch item details:', error);
                updatedRecipe[index] = { ...updatedRecipe[index], servingSize: '' };
            }
        } else {
            updatedRecipe[index][name] = value;
        }
        setRecipeItems(updatedRecipe);
    };

    const handleRemoveItem = (index) => {
        setRecipeItems(recipeItems.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const recipeData = {
            name: recipeName,
            items: recipeItems.map(({ itemID, servingsEaten }) => ({
                itemID: parseInt(itemID, 10),
                numServings: parseFloat(servingsEaten) // Fix the API parameter name
            }))
        };

        try {
            const response = await catalogApi.createRecipe(recipeData);
            if (response.status >= 200 && response.status < 300) {
                setBanner({ message: 'Recipe created successfully!', type: 'success' });
                setRecipeItems([]);
                setRecipeName('');
            } else {
                throw new Error(response.data?.msg || 'Recipe creation failed!');
            }
        } catch (error) {
            console.error('Failed to create recipe:', error);
            setBanner({ message: error.message || 'Recipe creation failed!', type: 'failure' });
        }

        setTimeout(() => setBanner({ message: '', type: '' }), 4000);
    };

    return (
        <div>
            <NavBar />
            <div className="form-container">
                {banner.message && <div className={`banner ${banner.type}`}>{banner.message}</div>}
                <form onSubmit={handleSubmit} className="recipe-form">
                    <div className="form-group">
                        <label>Recipe Name:</label>
                        <input type="text" value={recipeName} onChange={(e) => setRecipeName(e.target.value)} placeholder="Enter recipe name" required />
                    </div>
                    {recipeItems.map((item, index) => (
                        <div key={index} className="recipe-item">
                            <label>Item:</label>
                            <select name="itemID" value={item.itemID} onChange={(e) => handleItemChange(index, e)}>
                                <option value="">Please Select</option>
                                {items.map(option => (
                                    <option key={option.id} value={option.id}>{option.name}</option>
                                ))}
                            </select>
                            <label>Servings:</label>
                            <input type="number" name="servingsEaten" min="0.1" step="0.01" value={item.servingsEaten} onChange={(e) => handleItemChange(index, e)} />
                            <span className="serving-size">{item.servingSize}</span>
                            <button type="button" className="remove-btn" onClick={() => handleRemoveItem(index)}>Remove</button>
                        </div>
                    ))}
                    <button type="button" className="add-btn" onClick={handleAddItem}>+ Add Item</button>
                    <button type="submit" className="submit-btn" disabled={recipeItems.length === 0 || !recipeName.trim()}>Submit Recipe</button>
                </form>
            </div>
        </div>
    );
};

export { CreateRecipeScreen };
